module.exports = __webpack_public_path__ + "assets/img/robot_test_l2.d2d3952e.jpg";